/** Key-value persistence behind an interface so services stay UI- and platform-free (R1: Capacitor Preferences). */
export interface KV {
  get(key: string): string | null;
  set(key: string, value: string): void;
  remove(key: string): void;
}

export class MemoryKV implements KV {
  readonly data = new Map<string, string>();
  get(key: string): string | null {
    return this.data.get(key) ?? null;
  }
  set(key: string, value: string): void {
    this.data.set(key, value);
  }
  remove(key: string): void {
    this.data.delete(key);
  }
}

/** localStorage-backed KV. Falls back to memory when storage is unavailable (private mode, blocked). */
export function browserKV(prefix = 'mp:'): KV {
  const ls = probeLocalStorage();
  if (!ls) return new MemoryKV();
  return {
    get: (k) => ls.getItem(prefix + k),
    set: (k, v) => ls.setItem(prefix + k, v),
    remove: (k) => ls.removeItem(prefix + k),
  };
}

function probeLocalStorage(): Storage | null {
  if (typeof localStorage === 'undefined') return null;
  const probe = '__mp_probe__';
  try {
    localStorage.setItem(probe, '1');
    localStorage.removeItem(probe);
    return localStorage;
  } catch {
    // storage exists but is blocked (Safari private mode, quota 0): play without persistence
    return null;
  }
}
